  // au-redthread
  export const environment = {
    production: true,
    serverUrl: 'https://fzgume10w0.execute-api.ap-southeast-2.amazonaws.com/dev',
    bucket: 'redthread-au-upload',
    userPool: {
      UserPoolId: 'ap-southeast-2_nmcp9aUb3',
      ClientId: '3re0lf4mdouqe2in24u6qcvouq',
      region: 'ap-southeast-2'
    },
    identityPoolId: 'ap-southeast-2:3e27a5de-681b-42e2-81be-e9b7275c98bb',
    buckets: {
      'us-east-2': 'redthread-au-upload'
    },
    defaultRegion: 'ap-southeast-2',
    cognito: {
      identityPoolId:'ap-southeast-2:3e27a5de-681b-42e2-81be-e9b7275c98bb', //REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'ap-southeast-2_nmcp9aUb3', //OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '3re0lf4mdouqe2in24u6qcvouq', //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'redthread-au-upload', //REQUIRED -  Amazon S3 bucket
        region: 'ap-southeast-2', //OPTIONAL -  Amazon service region
      }
    }
  };

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolClientId: '3re0lf4mdouqe2in24u6qcvouq',
      userPoolId: 'ap-southeast-2_nmcp9aUb3',
      identityPoolId:'ap-southeast-2:3e27a5de-681b-42e2-81be-e9b7275c98bb'
    }
  },
  Storage: {
    S3: {
      bucket: 'redthread-au-upload',
      region: 'ap-southeast-2',
    }
  }
//   'aws_project_region': 'ap-southeast-2',
//   'aws_cognito_region': 'ap-southeast-2',
//   'aws_user_pools_id': 'ap-southeast-2_nmcp9aUb3',
//   'aws_user_pools_web_client_id': '3re0lf4mdouqe2in24u6qcvouq',
//   'aws_cognito_mfa_configuration': 'ON'
};
export default awsconfig;